import React from 'react'

import WorkWithUs from '../components/Pages/WorkWithUs'

const WorkWithUsPage = ({ location }) => {
  return <WorkWithUs location={location} localeID="sk_SK" />
}

export default WorkWithUsPage
